interface BrandItem {
  name: string;
  imageUrl: string;
}

const brandData: BrandItem[] = [
  {
    name: 'Nike',
    imageUrl: 'https://readdy.ai/api/search-image?query=Single%20iconic%20Nike%20Air%20Max%20sneaker%20displayed%20on%20a%20textured%20stone%20pedestal%20with%20dramatic%20side%20lighting%20creating%20bold%20shadows%20against%20a%20warm%20cream%20wall%20editorial%20fashion%20photography%20high%20contrast%20artistic%20composition&width=800&height=1067&seq=brand-nike-v3&orientation=portrait&nocache=true',
  },
  {
    name: 'Adidas',
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20Adidas%20originals%20sneaker%20with%20iconic%20three%20stripes%20placed%20on%20a%20warm%20terracotta%20surface%20with%20soft%20natural%20window%20light%20revealing%20suede%20texture%20details%20lifestyle%20product%20photography%20clean%20composition&width=800&height=1067&seq=brand-adidas-v3&orientation=portrait&nocache=true',
  },
  {
    name: 'Jordan',
    imageUrl: 'https://readdy.ai/api/search-image?query=Air%20Jordan%20basketball%20sneaker%20suspended%20artistically%20with%20subtle%20fishing%20line%20against%20a%20warm%20gradient%20beige%20backdrop%20dramatic%20studio%20lighting%20emphasizing%20silhouette%20and%20design%20details%20editorial%20sneaker%20photography&width=800&height=1067&seq=brand-jordan-v3&orientation=portrait&nocache=true',
  },
];

export default function BrandFeature() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
          Beliebte Marken
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-10 max-w-xl">
          Entdecke die angesagtesten Brands auf Taobao & Weidian — alle mit dem OOPBUY Spreadsheet verwaltbar.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {brandData.map((brand) => (
            <a
              key={brand.name}
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group relative aspect-[3/4] rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src={brand.imageUrl}
                alt={`${brand.name} Produkte OOPBUY Spreadsheet`}
                title={`${brand.name} Spreadsheet Deutschland`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="font-heading text-2xl md:text-3xl font-bold text-white">{brand.name}</h3>
                <p className="text-white/70 text-sm mt-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  Jetzt entdecken →
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}